<template>
  <!-- 选择培训人员弹窗 -->
  <el-dialog title="选择参与对象" :visible.sync="isShow" width="70%">
    <el-tabs tab-position="left" style="height: 490px;">
      <el-tab-pane class="tab-content">
        <span slot="label" class="tab-label"><i class="fa fa-user fa-lg tab-icon"></i>员工</span>
        <empSelection ref="empSelection" @selection-change="empChange"></empSelection>
      </el-tab-pane>
      <el-tab-pane class="tab-content">
        <span slot="label" class="tab-label"><i class="fa fa-users fa-lg tab-icon"></i>部门</span>
        <deptSelection ref="deptSelection" @selection-change="deptChange"></deptSelection>
      </el-tab-pane>
<!--      <el-tab-pane class="tab-content">-->
<!--        <span slot="label" class="tab-label"><i class="fa fa-key fa-lg tab-icon"></i>角色</span>-->
<!--        <roleSelection ref="roleSelection" @selection-change="roleChange"></roleSelection>-->
<!--      </el-tab-pane>-->
      <el-tab-pane class="tab-content">
        <span slot="label" class="tab-label"><i class="fa fa-user fa-lg tab-icon"></i>人员类型</span>
        <typeSelection ref="typeSelection" @selection-change="typeChange"></typeSelection>
      </el-tab-pane>
    </el-tabs>
    <batchBox id="batch-box" :title="'选中对象列表'" :props="batchBoxProps" @selection-change-remove="selectionChangeRemove" ref="batchBox"></batchBox>
    <span slot="footer">
        <el-button style="float: right; margin-bottom: 8px" type="primary" size="small" @click="ok">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>

import batchBox from '@/pages/trainingManagement/component/batchBox.vue';
import empSelection from '@/pages/trainingManagement/component/user/empSelection.vue';
import deptSelection from '@/pages/trainingManagement/component/user/deptSelection.vue';
import roleSelection from '@/pages/trainingManagement/component/user/roleSelection.vue';
import typeSelection from "@/pages/trainingManagement/component/user/typeSelection";

export default {
  name: "userSelection",
  components: {batchBox, empSelection, deptSelection, roleSelection,typeSelection},
  data() {
    return {
      isShow: false,
      batchBoxProps: {
        value: 'key',      // ID字段名
        label: 'label',   // 显示名称
      },
      selectionEmpData: [],
      selectionDeptData: [],
      selectionRoleData: [],
      selectionTypeData:[],

      selectionDataCompare: [],
      //选中数据
      selectionData: [],
      keyId:'',
      keyName:''
    }
  },
  methods: {
    ok() {
      this.selectionData = [];
      // console.log(this.selectionDataCompare)
      this.selectionData.push.apply(this.selectionData, this.selectionEmpData);
      this.selectionData.push.apply(this.selectionData, this.selectionDeptData);
      this.selectionData.push.apply(this.selectionData, this.selectionRoleData);

      this.selectionData.push.apply(this.selectionData, this.selectionTypeData);

      if(this.keyId != null && this.keyName !=null || this.keyId!= ''&& this.keyName!=''){

          this.selectionData.map(item =>{
            this.selectionDataCompare.map( s =>{
              if(item[this.keyId] === s[this.keyId] || item[this.keyName] === s[this.keyName]){
                for(let ke in s){
                  // item.push.apply(item,ke,s[ke])
                  this.$set(item,ke,s[ke])
                }
              }

            })
          })
      }

      this.isShow =  false;
      //发布事件
      this.$emit("submit", this.selectionData);
    },
    /*****
     * 带有自定义参数的
     * 展示
     * @param rows 已选中数据
     * @param keyId id的key
     * @param keyName name的key
     */
    showCompare(rows,keyId,keyName) {

      console.log(keyId)
      console.log(keyName)
      this.$nextTick(() => {
        this.isShow = true;

        if (rows && rows.length > 0) {
          this.keyId=keyId;
          this.keyName=keyName;
          this.selectionDataCompare=rows;

          this.selectionEmpData = [];
          this.selectionDeptData = [];
          this.selectionRoleData = [];

          this.selectionTypeData=[];
          rows.forEach(row => {
            if (row.personType == "0") {
              this.selectionEmpData.push(row);
            } else if (row.personType == "1") {
              this.selectionDeptData.push(row);
            }  else if (row.personType == "3") {
              this.selectionRoleData.push(row);
            }else  if(row.personType =="4"){
              this.selectionTypeData.push(row)
            }
          })
          this.changeBox();
          this.$refs.empSelection.setSelection(this.selectionEmpData);
          this.$refs.deptSelection.setSelection(this.selectionDeptData);
          this.$refs.roleSelection.setSelection(this.selectionRoleData);
          this.$refs.typeSelection.setSelection(this.selectionTypeData);
        } else {
          this.clearAll();
        }
      });
    },
    /**
     * 展示
     * @param rows 已选中数据
     */
    show(rows) {
      this.$nextTick(() => {
        this.isShow = true;
        if (rows && rows.length > 0) {
          this.selectionEmpData = [];
          this.selectionDeptData = [];
          this.selectionRoleData = [];
          this.selectionTypeData=[];
          rows.forEach(row => {
            if (row.personType == "0") {
              this.selectionEmpData.push(row);
            } else if (row.personType == "1") {
              this.selectionDeptData.push(row);
            }  else if (row.personType == "3") {
              this.selectionRoleData.push(row);
            }  else if (row.personType == "4") {
              this.selectionTypeData.push(row);
            }
          })
          this.changeBox();
          this.$refs.empSelection.setSelection(this.selectionEmpData);
          this.$refs.deptSelection.setSelection(this.selectionDeptData);
          this.$refs.roleSelection.setSelection(this.selectionRoleData);
          this.$refs.typeSelection.setSelection(this.selectionTypeData);
        } else {
          this.clearAll();
        }
      });
    },
    empChange(rows) {
      this.selectionEmpData = rows;
      this.changeBox();
    },
    deptChange(rows) {
      this.selectionDeptData = rows;
      this.changeBox();
    },

    roleChange(rows) {
      this.selectionRoleData = rows;
      this.changeBox();
    },
    typeChange(rows){
      this.selectionTypeData=rows;
      this.changeBox();
      console.log(rows)
    },
    changeBox() {
      this.selectionData = [];
      this.selectionData.push.apply(this.selectionData, this.selectionEmpData);
      this.selectionData.push.apply(this.selectionData, this.selectionDeptData);
      this.selectionData.push.apply(this.selectionData, this.selectionRoleData);
      this.selectionData.push.apply(this.selectionData, this.selectionTypeData);
      this.$refs.batchBox.setSelection(this.selectionData);
    },
    clearAll() {
      this.selectionData = [];
      this.selectionEmpData = [];
      this.selectionDeptData = [];
      this.selectionRoleData = [];
      this.selectionTypeData=[];
      this.$nextTick(() => {
        this.$refs.empSelection.setSelection(this.selectionEmpData);
        this.$refs.deptSelection.setSelection(this.selectionDeptData);
        this.$refs.roleSelection.setSelection(this.selectionRoleData);
        this.$refs.typeSelection.setSelection(this.selectionTypeData);
        this.$refs.batchBox.setSelection([]);
      });
    },
    getDataByPersonType(dataList, personType){
      let targetDataList = [];
      if (dataList) {
        dataList.forEach(obj => {
          if (obj.personType == personType) {
            targetDataList.push(obj);
          }
        })
      }
      return targetDataList;
    },
    selectionChangeRemove(old, rows) {
      if (old.personType == "0") {
        this.selectionEmpData = this.getDataByPersonType(rows, "0")
        this.$refs.empSelection.setSelection(this.selectionEmpData);
      } else if (old.personType == "1") {
        this.selectionDeptData = this.getDataByPersonType(rows, "1")
        this.$refs.deptSelection.setSelection(this.selectionDeptData);
      }  else if (old.personType == "3") {
        this.selectionRoleData = this.getDataByPersonType(rows, "3")
        this.$refs.roleSelection.setSelection(this.selectionRoleData);
      } else if (old.personType == "4") {
        this.selectionTypeData = this.getDataByPersonType(rows, "4")
        this.$refs.typeSelection.setSelection(this.selectionTypeData);
      }
    }
  }
}
</script>

<style scoped>
  .tab-icon {
    margin-right: 5px;
  }

  .tab-label {
    font-weight: normal !important;
    font-style: normal !important;
  }

  .tab-content {
    padding-left: 15px;
  }

  #batch-box {
    margin-top: 10px;
    height: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/user/userSelection.vue